import classNames from "classnames"
import { LimitedTech } from "./LimitedTech"

const viziers = [2059627, 2059346, 2073116, 2059331, 9000336, 9000566, 2059527, 2059828, 9000513, 2063087, 2059610, 9000512]

export function VizierDisplay({ upgrades, hasImperialCouncil, leftSide }) {

    let arrayLength = hasImperialCouncil ? 8 : 5

    let vizierUpgrades = upgrades.filter(r => viziers.includes(parseInt(r)))
    console.log(vizierUpgrades)

    //I got lazy, this should be a map or something more elegant
    return (<div className={classNames("flex flex-row justify-between w-[216px]", leftSide ? '' : 'items-start')}>
        <LimitedTech pbg_id={vizierUpgrades[0]} border={false}/>
        <img className='h-2 -mx-3 my-auto' src='/vizier/arrow.png' alt="" />
        <LimitedTech pbg_id={vizierUpgrades[1]} border={false}/>
        <img className='h-2 -mx-3 my-auto' src='/vizier/arrow.png' alt="" />
        <LimitedTech pbg_id={vizierUpgrades[2]} border={false}/>
        <img className='h-2 -mx-3 my-auto' src='/vizier/arrow.png' alt="" />
        <LimitedTech pbg_id={vizierUpgrades[3]} border={false}/>
        <img className='h-2 -mx-3 my-auto' src='/vizier/arrow.png' alt="" />
        <LimitedTech pbg_id={vizierUpgrades[4]} border={false}/>
        {hasImperialCouncil &&
            <>
                <img className='h-2 -mx-3 my-auto' src='/vizier/arrow.png' alt="" />
                <LimitedTech pbg_id={vizierUpgrades[5]} border={false}/>
                <img className='h-2 -mx-3 my-auto' src='/vizier/arrow.png' alt="" />
                <LimitedTech pbg_id={vizierUpgrades[6]} border={false}/>
                <img className='h-2 -mx-3 my-auto' src='/vizier/arrow.png' alt="" />
                <LimitedTech pbg_id={vizierUpgrades[7]} border={false}/>
            </>
        }
    </div>
    )
}